<script>
/**
 * Dashboard Component
 */
export default {
  props: {
    fields: Array,
    rowFilters: {
      type: Boolean,
      default: false,
    },
    items: Array,
    id: {
      type: String,
      default: 'pagination-grid',
    },
    headVariant: {
      type: String,
      default: 'light',
    },
    border: {
      type: Boolean,
      default: false,
    },
    noTopBorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    toggleColumn(columnKey) {
      if (this.hiddenColumns.includes(columnKey)) {
        this.hiddenColumns = this.hiddenColumns.filter((x) => x !== columnKey);
      } else {
        this.hiddenColumns = [...this.hiddenColumns, columnKey];
      }
    },
  },
  computed: {
    rows() {
      if (this.items == null || this.items == undefined) {
        return 0;
      }

      return this.items.length;
    },
    nbPages() {
      return Math.ceil(this.rows / this.itemsPerPage);
    },
    rowFiltersAvailable() {
      return this.rowFilters && this.id != 'pagination-grid';
    },
    gridConfigText() {
      return 'gridConfig-' + this.id;
    },
    gridConfig: {
      get() {
        return this.$store.getters['localstorage/getDynamicConfigs'](
          this.gridConfigText
        );
      },
      set(value) {
        this.$store.dispatch('localstorage/setDynamicConfig', {
          code: this.gridConfigText,
          config: value,
        });
      },
    },
    itemsPerPage: {
      get() {
        return this.gridConfig.itemsPerPage;
      },
      set(value) {
        this.gridConfig = {
          ...this.gridConfig,
          itemsPerPage: value,
        };
      },
    },
    hiddenColumns: {
      get() {
        return this.gridConfig.hiddenColumns;
      },
      set(value) {
        this.gridConfig = {
          ...this.gridConfig,
          hiddenColumns: value,
        };
      },
    },
    fieldsFiltered() {
      return this.fields.filter((x) => !this.hiddenColumns.includes(x.key));
    },
  },
  watch: {
    rows() {
      if (this.nbPages < this.currentPage) {
        this.currentPage = this.nbPages > 1 ? this.nbPages : 1;
      }
    },
  },
};
</script>

<template>
  <div class="relative-positioning customScrollbar">
    <div v-if="rowFiltersAvailable" class="absolute-positioning">
      <b-dropdown
        class="cogDropdown"
        toggle-class="m-0 flex-vertical-center"
        id="dropdown-2"
        right
        variant="primary"
        :text="$t('general.columns')"
        style="height: 40px"
      >
        <template #button-content>
          <i style="font-size: 1.6em" class="bx bx-cog"></i>
        </template>
        <template v-for="field in fields">
          <b-dropdown-form v-if="field.label != ''" :key="field.key">
            <b-form-checkbox
              :checked="!hiddenColumns.includes(field.key)"
              @change="toggleColumn(field.key)"
              class="mr-3"
              size="md"
              switch
            >
              <span style="white-space: nowrap">
                {{ field.label }}
              </span>
            </b-form-checkbox>
          </b-dropdown-form>
        </template>
      </b-dropdown>
    </div>

    <div
      class="d-flex flex-column customScrollbar relative-positioning"
      style="overflow-x: scroll"
      :class="{ 'border-around': border }"
    >
      <b-table
        :id="id"
        :items="items"
        :per-page="itemsPerPage"
        sort-by="status"
        :current-page="currentPage"
        :fields="fieldsFiltered"
        sort-icon-left
        thead-class="nowrap-header"
        :thead-tr-class="{ 'no-border-top': noTopBorder }"
        hover
        :head-variant="headVariant"
        class="mb-0"
      >
        <template
          v-for="(x, slotName) in $scopedSlots"
          v-slot:[slotName]="context"
        >
          <slot :name="slotName" v-bind="context" />
        </template>
      </b-table>
    </div>
    <b-container fluid v-if="rows > 10" class="mt-2">
      <b-row>
        <b-col md="6" offset-md="3">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="itemsPerPage"
            :aria-controls="id"
            align="center"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
          >
          </b-pagination>
        </b-col>
        <b-col align-self="center">
          <b-form-group
            class="d-flex mr-4 justify-content-end"
            :label="$t('general.itemPerPage')"
            label-for="pagesize-input"
          >
            <b-form-select
              class="ml-2"
              id="pagesize-input"
              label-field="Per page"
              v-model="itemsPerPage"
              :options="[10, 50, 100]"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
.border-around {
  border: 1px solid #eff2f7;
}

.absolute-positioning {
  position: absolute;
  right: 0;
  top: -56px;
}

.relative-positioning {
  position: relative;
}
</style>

<style>
.no-border-top > th {
  border-top: none !important;
}
.nowrap-header > tr > th {
  white-space: nowrap !important;
}
</style>